import { useState, useEffect } from 'react'
import { languageUtil, onLanguageChange } from '../../util/languageUtils'
import { useCurrency } from '../../util/CurrencyContext'
import { supportedCurrencies } from '../../constants'

const LanguageCurrencyButton = ({ onOpenModal }) => {
    const { language, setLanguage } = languageUtil()
    const { currency, currencySymbol } = useCurrency()
    const [currentLang, setCurrentLang] = useState(language)

    useEffect(() => {
        const unsubscribe = onLanguageChange(setCurrentLang)
        return () => unsubscribe()
    }, [])

    const toggleLanguage = () => {
        const newLang = currentLang === 'en' ? 'ar' : 'en'
        setLanguage(newLang)
    }

    return (
        <button
            onClick={onOpenModal}
            className='flex items-center gap-2 px-3 py-1.5 transition-all duration-100 ease-out rounded shadow-sm text-gray-900 bg-white border border-gray-300 hover:bg-gray-50 active:scale-95 hover:scale-[1.02] focus:outline-yellow-500'
        >
            {/* Language Flag */}
            <img
                src={currentLang === 'en' ? '/img/lang/GB.png' : '/img/lang/SA.png'}
                className='object-cover w-6 h-4 rounded-sm'
                alt={currentLang === 'en' ? 'English' : 'Arabic'}
            />

            {/* Separator */}
            <span className='w-px h-4 bg-gray-300'></span>

            {/* Currency */}
            <div className='flex items-center gap-1'>
                <span className='text-sm font-medium'>{currency}</span>
                <span className='text-xs text-gray-500'>({currencySymbol})</span>
            </div>
        </button>
    )
}

export default LanguageCurrencyButton
